export var isArray = Array.isArray;